import {Component, Input, Output, EventEmitter} from '@angular/core';
import {Variation, VariationAssignment} from '@emm/common-items/models/variation.model';

@Component({
    selector: 'emm-assignments-card',
    templateUrl: './assignments-card.component.html',
    styleUrls: ['./assignments-card.component.scss']
})
export class AssignmentsCardComponent {
    @Input() variation: Variation;
    @Input() assignments: VariationAssignment[];
    @Input() itemTag: string;
    @Input() hideButtons: boolean;
    @Input() isSuperAdmin: boolean;

    @Output() createAssignment = new EventEmitter<void>();
    @Output() editAssignment = new EventEmitter<VariationAssignment>();

    onCreateAssignment() {
        this.createAssignment.emit();
    }

    onEditAssignment(assignment: VariationAssignment) {
        this.editAssignment.emit(assignment);
    }
}
